// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon_warning .circle[data-v-500e7ade]{stroke:#F87900}.icon_warning .mark[data-v-500e7ade]{stroke:none;fill:#F87900}.icon_warning .dot[data-v-500e7ade]{stroke:none;fill:#F87900}.icon_info .circle[data-v-500e7ade]{stroke:#0A5CD7}.icon_info .mark[data-v-500e7ade]{stroke:none;fill:#0A5CD7}.icon_info .dot[data-v-500e7ade]{stroke:none;fill:#0A5CD7}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
